<div class="competitor-rate-detail-list">
  <table class="table table-striped table-sm" *ngIf="competitorRates?.length; else noRates">
    <thead>
      <tr>
        <th>Competitor</th>
        <th class="text-center">Distance</th>
        <th class="text-end">Rate</th>
        <th class="text-end">vs. You</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let rate of competitorRates">
        <td>
          <div>{{ rate.CompetitorName }}</div>
          <div class="text-muted">{{ rate.Address }}</div>
        </td>
        <td class="text-center">{{ rate.DistanceMiles != null ? ((rate.DistanceMiles | number:'1.0-2') + ' mi') : '—' }}</td>
        <td class="text-end">{{ rate.IsAvailable ? (rate.Rate | customCurrency) : 'Unavailable' }}</td>
        <td class="text-end">{{ rate.VsYou | customCurrency }}</td>
      </tr>
    </tbody>
  </table>
  <ng-template #noRates>
    <p class="text-muted mb-0">No competitor rates available for this unit type.</p>
  </ng-template>
</div>
